/** @format */

import React, { useCallback } from "react";
import { Button } from "primereact/button";
import ThreeDotsLoader from "../common/ThreeDotsLoader";

import "primeflex/primeflex.css";
import useDeleteSurvey from "./hooks/useDeleteSurvey";
import { useQueryClient } from "@tanstack/react-query";
import "../../style/news.css";

const Delete = ({ id, toastRef, resetView }) => {
  const mutation = useDeleteSurvey(id);
  const queryClient = useQueryClient();
  const deleteHandler = useCallback(() => {
    mutation.mutate(id, {
      onSuccess: () => {
        toastRef.current.show({
          severity: "success",
          summary: "Success",
          detail: "Survey deleted successfully",
          life: 1000,
        });
        queryClient.invalidateQueries({
          queryKey: ["getAllSurvey"],
        });
      },
      onError: () => {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error deleting Survey",
          life: 1000,
        });
      },
    });
  }, [id, queryClient, mutation, toastRef]);
  const isLoading = mutation.isLoading;
  const deleteText = "Are you sure you want to Delete?";
  return (
    <>
      {isLoading ? (
        <div className='wtg__loader'>
          <ThreeDotsLoader />
        </div>
      ) : null}
      <p>{deleteText}</p>
      <Delete.Footer deleteHandler={deleteHandler} resetView={resetView} />
    </>
  );
};

Delete.Footer = ({ deleteHandler, resetView }) => (
  <div className='p-dialog-footer'>
    <Button label='Yes' onClick={deleteHandler} className='p-button p-button-sm btn3' />
    <Button label='No' onClick={resetView} className='p-button p-button-sm btn3' />
  </div>
);

Delete.Header = () => <p>Delete Survey</p>;

export default Delete;
